import React, {Component} from 'react';
import SchemasComponent from './LeadSchemas';
import schemaModel from '../../../../model/leadSchema';
import withRouter from '/src/components/misc/withRouter';

class LeadSchemasContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      schemas: null,
      limit: 20,
      offset: 0,
      total: null,
      working: true
    };
  }

  componentDidMount() {
    document.title = 'Admin - Skjemaer';
    return Promise.all([schemaModel.getAll()]).then(([schemas]) => {
      this.setState({
        schemas: schemas,
        working: false
      });
    });
  }

  render() {
    return (
      <SchemasComponent
        schemas={this.state.schemas}
        total={this.state.total}
        limit={this.state.limit}
        offset={this.state.offset}
        working={this.state.working}
      />
    );
  }
}

export default withRouter(LeadSchemasContainer);
